import { useRef, useState } from 'react';
import { Button } from '@repo/ui/src/components/ui/button';
import { MerchantLogoCropDialog } from './MerchantLogoCropDialog';
import { useMerchantLogo, useUploadMerchantLogo } from '../../hooks/usePlatformConfig';

export function MerchantLogoTab() {
  const { data, isLoading } = useMerchantLogo();
  const upload = useUploadMerchantLogo();
  const inputRef = useRef<HTMLInputElement>(null);
  const [pending, setPending] = useState<string | null>(null);

  return (
    <div className="max-w-2xl space-y-6">
      <section className="rounded-lg border border-surface-200 bg-surface-0 p-5">
        <h3 className="text-sm font-semibold text-surface-800">Logo merchant</h3>
        <p className="mt-1 text-[13px] text-surface-500">
          Hiện trên trang liên kết ngân hàng của SePay mà giáo viên nhìn thấy. Ảnh vuông 1:1.
        </p>
        <div className="mt-3">
          {isLoading ? (
            <span className="text-[13px] text-surface-400">…</span>
          ) : data?.logoUrl ? (
            <img src={data.logoUrl} alt="Logo merchant" className="h-24 w-24 rounded border border-surface-200 object-cover" />
          ) : (
            <span className="text-[13px] text-surface-400">Chưa có logo.</span>
          )}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="image/png,image/jpeg,image/webp"
          className="hidden"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) setPending(URL.createObjectURL(file));
            e.target.value = '';
          }}
        />
        <Button className="mt-4" variant="outline" disabled={upload.isPending} onClick={() => inputRef.current?.click()}>
          Đổi logo
        </Button>
      </section>

      {pending && (
        <MerchantLogoCropDialog
          open
          imageSrc={pending}
          onOpenChange={(o) => {
            if (!o) {
              URL.revokeObjectURL(pending);
              setPending(null);
            }
          }}
          onCropped={(blob) => {
            upload.mutate(blob);
            URL.revokeObjectURL(pending);
            setPending(null);
          }}
        />
      )}
    </div>
  );
}
